/** Menu routes (core.menu.name) checked exactly with RoleService.hasExactRouteRoles/hasExactRouteAccess. */
export const CUSTOMER_USERS_TAB_ROUTE = '/space/customers/profiles/registered/:id/users';
export const CUSTOMER_API_ACCESS_TAB_ROUTE = '/space/customers/profiles/registered/:id/api-access';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/security/permission-routes.ts